export default __webpack_public_path__ + "static/media/imageBio.be009742.png";